import {ShapeCommand} from 'src/app/commands/commands.template';
import {
  ActivityOrgModelNodesAttachmentCreateAction,
  ActivityOrgModelNodesAttachmentDeleteAction
} from 'src/app/shared/models/activity-org-model-nodes-attachment-actions.interface';
import {OrgModelNodesAttachment} from 'src/app/shared/models/org-model-nodes-attachment.interface';

export class ActivityDeleteOrgModelNodesAttachmentCommand extends ShapeCommand {
  protected services: {[key: string]: any};
  protected object: OrgModelNodesAttachment[];

  public execute() {
    const action: ActivityOrgModelNodesAttachmentDeleteAction = {
      deleteOrgModelNodesAttachment: this.object
    };

    return this.services.diagramUpdateSvc.update(action, true, false, false).then(result => {
      this.redrawActivity();

      return result;
    });
  }

  public reverse() {
    const action: ActivityOrgModelNodesAttachmentCreateAction = {
      createOrgModelNodesAttachment: this.object
    };

    return this.services.diagramUpdateSvc.update(action).then(result => {
      this.redrawActivity();

      return result;
    });
  }

  private redrawActivity(): void {
    const {itemMxKey: mxKey} = this.object[0];

    this.services.editorRegistrySvc.getGraph().model.getCell(mxKey).comp.instance.setupFromJson();
  }
}
